import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CdwIconModule } from '@cdw-ae/common-ui-components-icon';

import { CdwMessageBandComponent } from './cdw-message-band/cdw-message-band.component';

@NgModule({
  imports: [CommonModule, CdwIconModule],
  declarations: [CdwMessageBandComponent],
  exports: [CdwMessageBandComponent],
})
export class CdwMessageBandModule {}
